import { render } from "./TheIntroduce.vue?vue&type=template&id=9e0daa92"
const script = {}
script.render = render

export default script